import axios from '../../utils/axios.js'

export const query = (query) => axios.setAxiosGetPromise('role', query)

export const template = (query) => axios.setAxiosGetPromise('role/template', query)

export const getRole = (query) => axios.setAxiosGetPromise('role/findOne', query)

export const add = (options) => axios.setAxiosPostPromise('role', options)

export const update = (id, options) => axios.setAxiosPutPromise('role/' + id, options)

export const deleteRole = (query) => axios.setAxiosDeletePromise('role/deleteOne', query)



// WEBPACK FOOTER //
// ./src/services/system/role.js